<template>
  <step :context="{}">
    <div class="congrats">
      <img src="/images/congrats.svg" />
      <div class="header">Congratulations!</div>
      <div class="text">
        You have successfully set up your Basic Plan.
        Our sales team will reach out to you shortly with additional details!

        Once the sign-up process is complete, we will send the following materials to your mail:
        <ul>
          <li>Your Como Hub credentials</li>
          <li>A web portal link to sign up members via your website, social networks or other mediums</li>
          <li>Guides on signing up members and redeeming promotions via your POS</li>
          <li>Guides on how to operate your CRM dashboard and communicate with members via text messages/emails</li>
        </ul>
        Please reach out our Customer Support at <a href="mailto:sales@bonobo.com.tr">sales@bonobo.com.tr</a> with any questions.
      </div>
    </div>
  </step>
</template>

<script>
import Step from "./Step";
export default {
  components: {
    Step
  }
};
</script>

<style lang="scss" scoped>
.congrats {
  height: 100%;

  img {
    display: none;
  }
  background-image: url("/images/congrats.svg");
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-size: 68%;

  .header {
    font-size: 52px;
    font-weight: bold;
    color: #333d4d;
    margin: 58px 0 -10px;
  }

  .text {
    font-size: 18px;
    font-weight: 300;
    line-height: 1.56;
    max-width: 690px;
    color: #333d4d;
    white-space: pre-line;
    & .bold,a {
      font-weight: 500;
    }
    ul {
      list-style-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='10' viewBox='-1 -1 2 2'><circle r='0.4' /></svg>");
    }
    tab-size: 62px;
    text-shadow: white 1px 1px 1px;
  }

  #app.mobile & {
    height: fit-content;
    padding: 0 30px 40px;
    background-image: none;
    img {
      display: initial;
      width: 124vw;
      position: relative;
      left: calc(-15px - 12vw);
    }
    .header {
      font-size: 36px;
      margin: 0;
    }
  }
}
</style>